export const EQUIPMENT_SECTIONS = ['hvac', 'plumbing', 'electrical', 'water_treatment', 'air_quality'] as const;
export type EquipmentSection = (typeof EQUIPMENT_SECTIONS)[number];

export const EQUIPMENT_SECTION_LABELS: Record<EquipmentSection, string> = {
  hvac: 'HVAC',
  plumbing: 'Plumbing',
  electrical: 'Electrical',
  water_treatment: 'Water Treatment',
  air_quality: 'Air Quality',
};
